// extracted by extract-css-chunks-webpack-plugin
module.exports = {"switchCircle":"JpMYm","ios-switch":"AZuoP","onOffToggle":"T7N1v","onOffToggleSlider":"JkuUc","onOffToggleInput":"BibBj"};